import { axiosBaseQuery } from '../../lib/axios'
import { createApi } from '@reduxjs/toolkit/query/react'

export const FreeCouponApi = createApi({
  reducerPath: 'FreeCouponApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    payWithFreeCoupon: builder.mutation({
      query: (intent_id) => ({
        url: 'user/local-coupon/apply',
        method: 'POST',
        data: { intent_id },
      }),
    }),
  }),
})

export const { usePayWithFreeCouponMutation } = FreeCouponApi
